import PortalIdParser from 'PortalIdParser';
import { ANCHOR_TAG_LINK, OPEN_USE_CASE_MODAL_QUERY_PARAM } from '../constants/invoiceOnboarding';
import { getQuotesURL } from 'growth-payments-core/urls/urls';
export const getPaymentsEnrollmentUrl = () => `/commerce/${PortalIdParser.get()}/zero-state?paymentsEnrollment=processorPicker`;
export const getCommerceHomeURL = () => `/commerce/${PortalIdParser.get()}`;
export const getCommerceHomeUrlScrollToGetSetupGroup = () => `${getCommerceHomeURL()}#${ANCHOR_TAG_LINK.PAYMENTS_GET_SETUP}`;
export const getCommerceHomeUrlOpenUseCasesModal = () => `${getCommerceHomeURL()}?${OPEN_USE_CASE_MODAL_QUERY_PARAM}`;
export const getInvoicesIndexUrl = () => `/contacts/${PortalIdParser.get()}/objects/0-53/views/all/list`;
export const KB_PAYMENT_PROCESSING_FEES_URL = 'https://knowledge.hubspot.com/payment-processing/payments-frequently-asked-questions#rates-fees';
export const KB_INVOICES_SETUP_URL = 'https://knowledge.hubspot.com/invoices/set-up-the-hubspot-invoices-tool';
export const CPQ_QUOTE_THEME_SETTINGS_URL = `/theme-editor/${PortalIdParser.get()}/edit/@hubspot/cpq-theme`;
export const getIsCpqThemeEditorPath = path => path.includes('/theme-editor/') && path.includes('/edit/@hubspot/cpq-theme');
export const getTrialGuideUrl = () => `/trial-guide/${PortalIdParser.get()}/commerce-hub-professional`;
export const getCpqQuoteTemplatesUrl = () => `${getQuotesURL()}/templates`;
export const GLOBAL_HOME_URL = `/global-home/${PortalIdParser.get()}`;
const ONBOARDING_REFERRER_PARAMS = ['onboarding_referrer_task', 'onboarding_referrer_group', 'onboarding_referrer_source', 'via'];
const getOnboardingReferrerParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  return ONBOARDING_REFERRER_PARAMS.reduce((params, parameter) => {
    const value = urlSearchParams.get(parameter);
    if (value) {
      params.push(`${parameter}=${encodeURIComponent(value)}`);
    }
    return params;
  }, []).join('&');
};
export const appendOnboardingReferrerParams = url => {
  const onboardingReferrerParams = getOnboardingReferrerParams();
  if (!onboardingReferrerParams) {
    return url;
  }
  const [urlWithoutHash, hash = ''] = url.split('#');
  const [, query = ''] = urlWithoutHash.split('?');
  const urlSearchParams = new URLSearchParams(query);
  const paramsToAppend = onboardingReferrerParams.split('&').filter(param => !urlSearchParams.has(param.split('=')[0]));
  if (!paramsToAppend.length) {
    return url;
  }
  const queryParamSeparator = urlWithoutHash.includes('?') ? urlWithoutHash.endsWith('?') || urlWithoutHash.endsWith('&') ? '' : '&' : '?';
  return `${urlWithoutHash}${queryParamSeparator}${paramsToAppend.join('&')}${hash ? `#${hash}` : ''}`;
};